/* eslint-disable no-underscore-dangle */

let resolveReady!: () => void;
let rejectReady!: (reason?: unknown) => void;

window.__modulesConfigReady = new Promise<void>((resolve, reject) => {
  resolveReady = resolve;
  rejectReady = reject;
});

export function notifyModulesConfigLoaded(): void {
  resolveReady();
}

export function notifyModulesConfigFailed(reason?: unknown): void {
  rejectReady(reason);
}
